import {Options} from "flatpickr/dist/types/options";

const RequestFlatpickerDateTimeOptions: Partial<Options> = {
    dateFormat: "d.m.Y H:i",
    enableTime: true,
    locale: "sr",
    allowInput: true
}

export {RequestFlatpickerDateTimeOptions}